import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "./BaseURL/BaseURL";
import { Link } from "react-router-dom";

const BackgroundVideo = () => {
  const [bannerData, setBannerData] = useState({
    title: "",
    description: "",
    imageUrl: "",
    videoUrl: "",
    displayType: "image",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseurl}/banner-get`);
        const { Banner } = response.data;

        if (Banner && Banner.length > 0) {
          // Assuming you only want the first banner data
          const firstBanner = Banner[0];
          setBannerData({
            title: firstBanner.title,
            description: firstBanner.description,
            imageUrl: firstBanner.imageUrl || "",
            videoUrl: firstBanner.videoUrl || "",
            displayType:
              firstBanner.displayType ||
              (firstBanner.videoUrl && !firstBanner.imageUrl ? "video" : "image"),
          });
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures that this effect runs once when the component mounts

  console.log("Banner Data:", bannerData);

  return (
    <div className="relative w-full h-[420px] sm:h-[460px] md:h-[540px] lg:h-[620px] xl:h-[700px] overflow-hidden bg-black">
      {/* Background media: video or image based on admin choice */}
      {bannerData.displayType === "video" && bannerData.videoUrl && (
        <video
          src={bannerData.videoUrl}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          Your browser does not support the video tag.
        </video>
      )}

      {bannerData.displayType === "image" && bannerData.imageUrl && (
        <img
          src={bannerData.imageUrl}
          alt="Banner background"
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}

      {/* Dark gradient overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/10" />

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center h-full sm:mx-8">
        <h1 className="hidden md:block sm:text-3xl md:text-5xl mx-10 leading-tight text-white">
          <span className=" mb-2 font-bold">{bannerData.title}</span>
        </h1>

        <p className="mt-4 mx-10 text-xs md:w-[50%] lg:w-[30%] sm:text-lg text-white">
          {bannerData.description}
        </p>
        <Link to="/ProductPage">
          {" "}
          <button className="mx-10 mt-4 md:w-[30%] lg:w-[10%] bg-yellow-600 py-2 px-4 text-white font-bold rounded">
            Shop Now
          </button>
        </Link>
      </div>
    </div>
  );
};

export default BackgroundVideo;
